namespace TabAurous.Production {
    export namespace WIPTransactionDepartmentWiseService {
        export const baseUrl = 'Production/WIPTransactionDepartmentWise';

        export declare function List(request: TransactionRequest, onSuccess?: (response: Serenity.ListResponse<WIPTransactionRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "Production/WIPTransactionDepartmentWise/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>WIPTransactionDepartmentWiseService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
